import { Module } from 'vuex'
import { ILoginState } from './login-store-types'
import { IRootState } from '../types'
import { accountLogin, accountLogout } from '@/api/admin/loginApi'
import localCache from '@/utils/cache'
import router from '@/router'
import { getCurrentUserDetail } from '@/api/admin/userApi'
import { RouterVo, UserInfoVO } from '@/api/vo/user-vo'
import { getRouters } from '@/api/admin/menuApi'
import { mapMenusToRoutes } from '@/utils/map-menus'
import { clearSessionCache, removeDynamicRoutes } from '@/utils/auth-session'
import { resetTabList } from '@/hooks/tab-list-state'

const loginModule: Module<ILoginState, IRootState> = {
  namespaced: true,
  state() {
    return {
      token: '',
      userinfo: {},
      userMenus: [],
      permissions: []
    }
  },
  getters: {},
  mutations: {
    changeToken(state, token: string) {
      state.token = token
    },
    changeUserInfo(state, userInfo: UserInfoVO) {
      state.userinfo = userInfo
      // 获取用户按钮的权限
      const permissions = userInfo.permissions || []
      state.permissions = permissions
    },
    changeUserMenus(state, userMenus: RouterVo[]) {
      state.userMenus = userMenus
      //注册动态路由
      const routes = mapMenusToRoutes(userMenus)
      //把routers添加到 router
      // 动态添加路由
      if (routes.length > 0) {
        routes.forEach((route) => {
          router.addRoute('admin', route)
        })
      }
    },
    clearLoginState(state) {
      state.token = ''
      state.userinfo = {}
      state.userMenus = []
      state.permissions = []
    }
  },
  actions: {
    async accountLoginAction({ commit, dispatch }, payload: any) {
      const loginResult = await accountLogin({ ...payload })
      const token = loginResult.data?.token
      if (!token) {
        throw new Error('登录失败')
      }

      commit('changeToken', token)
      localCache.setCache('token', token)

      const userInfoResult = await getCurrentUserDetail()
      const userInfo = userInfoResult.data
      commit('changeUserInfo', userInfo)
      localCache.setCache('userInfo', userInfo)

      const userMenusResult = await getRouters()
      const userMenus = userMenusResult.data
      commit('changeUserMenus', userMenus)
      localCache.setCache('userMenus', userMenus)

      const firstMenu = localCache.getCache('firstMenu')
      if (firstMenu) {
        commit('changeFirstMenu', firstMenu, { root: true })
      }

      router.push('/admin')
      return true
    },
    loadLocalLogin({ commit, dispatch }) {
      const token = localCache.getCache('token')
      if (token) {
        commit('changeToken', token)
        // 发送初始化的请求(完整的role/department)
        dispatch('getInitialDataAction', null, { root: true })
      }
      const userInfo = localCache.getCache('userInfo')
      if (userInfo) {
        commit('changeUserInfo', userInfo)
      }
      const userMenus = localCache.getCache('userMenus')
      if (userMenus) {
        commit('changeUserMenus', userMenus)
      }
      const isCollapse = localCache.getCache('isCollapse')
      if (isCollapse) {
        commit('changeCollapse', isCollapse, { root: true })
      }
      const firstMenu = localCache.getCache('firstMenu')
      if (firstMenu) {
        commit('changeFirstMenu', firstMenu, { root: true })
      }
    },
    /**
     * 退出登录：先尽量通知服务端，无论成功失败都清理本地会话
     */
    async logoutAction({ commit, state }) {
      try {
        await accountLogout()
      } catch {
        // 退出接口失败仍清理本地，避免卡住无法登出
      } finally {
        removeDynamicRoutes(state.userMenus || [])
        clearSessionCache()
        resetTabList()
        commit('clearLoginState')
        commit('changeFirstMenu', {}, { root: true })
      }
    }
  }
}
export default loginModule
